import * as React from 'react'

import SitterReserveListPresenter from './presenter'

interface IProps {
  reserves: IReserveSummary[]
}

export const SitterReserveList = (props: IProps): JSX.Element => {
  return <SitterReserveListPresenter {...props} />
}

export default SitterReserveList
